import React from 'react';
import { useMenu } from 'hooks';
import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';

const PositionItem = ({
	position,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(position, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(position, e)}>
				Delete
			</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(position.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(position)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(position)}
						name="topic"
						color="primary"
					/>
				</TableCell>
			)}

			<TableCell>
				<Typography variant="primary.text">{position.name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{position.value}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{position?.description}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{position.created_at}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default PositionItem;
